/**
 * Hidden by default: xlsx is the durable answer to Excel-on-Windows mangling Hebrew text and
 * leading-zero phone numbers, but it pulls in a ~950KB dependency. Rolled out per account until
 * the affected customers confirm it solves what CSV can't.
 */
export const EXCEL_EXPORT_FEATURE_FLAG = 'feature-excel-export';

export enum ExportFormat {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export type ExportCellValue = string | number | boolean | null | undefined;

export type ExportColumn<TEntity> = {
  /** Stable id, never written to the file. Used for ordering and debugging. */
  key: string;
  /** Already localized by the caller — the export layer never sees a LabelData. */
  header: string;
  value: (entity: TEntity) => ExportCellValue;
};

/**
 * The single intermediate representation. Both writers consume only this, so a row-based export and
 * a server-generated CSV end up going through the same code.
 */
export type ExportTable = {
  headers: string[];
  rows: ExportCellValue[][];
  sheetName?: string;
};
